'use strict';

const React = require('react');
const PropTypes = require('prop-types');

function CarouselItem(props) {
    const { className, src, alt, index, ...restProps } = props;
    return <img src={src} alt={alt} className={className} data-index={index} {...restProps} />;
}

CarouselItem.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    className: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
};

module.exports = CarouselItem;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Carousel/CarouselItem.jsx